import TimeTrackingController from "../../../../APIController/TimeTrackingController"
import Text from "../../../../Components/Text"
import { useState, useEffect } from "react"
import CrudPage from "../../../../Components/CrudPage"
import { useModal } from "../../../../Components/Modal"
import { EditTimeTrackingForm } from "../Forms/EditTimeTrackingForm"

const toDateInputValue = (date) => date.toISOString().split("T")[0]

const formatDateTime = (isoString) => {
    if (!isoString) return null
    const withZ = isoString.endsWith("Z") ? isoString : `${isoString}Z`
    const date = new Date(withZ)
    const datePart = date.toLocaleDateString("de-CH", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    })
    const timePart = date.toLocaleTimeString("de-CH", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    })
    return `${datePart} ${timePart}`
}

const TimeTrackingManagement = () => {
    const { getStatisticsEntries } = TimeTrackingController()
    const today = toDateInputValue(new Date())
    const [startDate, setStartDate] = useState(today)
    const [endDate, setEndDate] = useState(today)
    const [entries, setEntries] = useState([])
    const {ModalView, openModal, closeModal} = useModal()

    useEffect(() => {
            fetchData()
        }, [startDate, endDate])

    const fetchData = async () => {
        if (!startDate || !endDate) return []
        const endOfDay = new Date(endDate)
        endOfDay.setDate(endOfDay.getDate() + 1)
        endOfDay.setHours(0, 0, 0, 0)
        const data = await getStatisticsEntries(new Date(startDate), endOfDay)
        setEntries(data)
    }

    const handleEditClick = (e, item) => {
            openModal(
                <EditTimeTrackingForm item={item} afterAction={() => {
                    fetchData()
                    closeModal()
                }} />
            )
        }

    return (
        <div className="w-full h-full flex flex-col min-h-0 overflow-hidden">
            <Text type="maintitle" classNames="w-full flex shrink-0">Stempelzeiten Verwalten</Text>
            <div className="flex gap-3 p-3 h-min w-full shrink-0">
                <div className="flex flex-col">
                    <label className="text-sm text-gray-600">Von</label>
                    <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="border rounded px-2 py-1"
                    />
                </div>
                <div className="flex flex-col">
                    <label className="text-sm text-gray-600">Bis</label>
                    <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="border rounded px-2 py-1"
                    />
                </div>
            </div>
            <div className="flex-1 min-h-0 overflow-hidden flex">
                <div className="w-full h-full flex flex-col min-h-0 p-3">
                    <div className="flex-1 min-h-0 overflow-y-auto">
                        <CrudPage
                            title={""}
                            noItemTitle={"Keine Stempelzeiten in dem Zeitraum"}
                            items={entries}
                            displayMethod={(item) => (
                                <>
                                    <Text type="itemmain">{item.user.firstName} {item.user.lastName}</Text>
                                    <Text type="itemtext">{`Startzeit: ${formatDateTime(item.startTime)}`}</Text>
                                    <Text type="itemtext">{`Endzeit: ${item.endTime ? formatDateTime(item.endTime) : "Nicht ausgestempelt"}`}</Text>
                                </>
                            )}
                            crudActions={[
                                { type: "edit", color: "black", action: handleEditClick, icon: "edit" }]}
                        />
                    </div>
                </div>
            </div>
            <ModalView classNames="w-auto" />
        </div>
    )
}

export default TimeTrackingManagement